var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.75C7.98 10.75 6.75 9.52 6.75 8C6.75 6.48 7.98 5.25 9.5 5.25C11.02 5.25 12.25 6.48 12.25 8C12.25 9.52 11.02 10.75 9.5 10.75ZM9.5 6.75C8.81 6.75 8.25 7.31 8.25 8C8.25 8.69 8.81 9.25 9.5 9.25C10.19 9.25 10.75 8.69 10.75 8C10.75 7.31 10.19 6.75 9.5 6.75Z",
    fill: "#60656C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.75H9.5C4.07 22.75 1.75 20.43 1.75 15V9C1.75 3.57 4.07 1.25 9.5 1.25H13.5C13.91 1.25 14.25 1.59 14.25 2C14.25 2.41 13.91 2.75 13.5 2.75H9.5C4.89 2.75 3.25 4.39 3.25 9V15C3.25 19.61 4.89 21.25 9.5 21.25H15.5C20.11 21.25 21.75 19.61 21.75 15V10C21.75 9.59 22.09 9.25 22.5 9.25C22.91 9.25 23.25 9.59 23.25 10V15C23.25 20.43 20.93 22.75 15.5 22.75Z",
    fill: "#60656C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5.75H16.25C15.84 5.75 15.5 5.41 15.5 5C15.5 4.59 15.84 4.25 16.25 4.25H21.75C22.16 4.25 22.5 4.59 22.5 5C22.5 5.41 22.16 5.75 21.75 5.75Z",
    fill: "#60656C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.5C18.59 8.5 18.25 8.16 18.25 7.75V2.25C18.25 1.84 18.59 1.5 19 1.5C19.41 1.5 19.75 1.84 19.75 2.25V7.75C19.75 8.16 19.41 8.5 19 8.5Z",
    fill: "#60656C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17029 19.7C2.93029 19.7 2.69029 19.58 2.55029 19.37C2.32029 19.03 2.41029 18.56 2.75029 18.33L7.68029 15.02C8.76029 14.3 10.2503 14.38 11.2303 15.21L11.5603 15.5C12.0603 15.93 12.9103 15.93 13.4003 15.5L17.5603 11.93C18.6303 11.02 20.2903 11.02 21.3603 11.93L22.9903 13.33C23.3003 13.6 23.3403 14.07 23.0703 14.39C22.8003 14.7 22.3303 14.74 22.0103 14.47L20.3803 13.07C19.8803 12.64 19.0303 12.64 18.5403 13.07L14.3803 16.64C13.3203 17.55 11.6503 17.55 10.5803 16.64L10.2503 16.35C9.79029 15.96 9.03029 15.92 8.52029 16.27L3.60029 19.58C3.46029 19.66 3.31029 19.7 3.17029 19.7Z",
    fill: "#60656C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMedia);
export default __webpack_public_path__ + "static/media/add_media.68096b402ff9b68698f967acb5b4682d.svg";
export { ForwardRef as ReactComponent };